import "./style.scss";
import SelectFilialUI from "@UI/SelectFilialUI";
import { useEffect, useMemo, useState } from "react";

const FilialBlock = ({ data, setFilialObj, filialObj, errorCity, errorFilial, setErrorFilial, setErrorCity, handleUpdateLocation = () => {}, cityArr = [] }) => {
    const [city, setCity] = useState(false);
    const [filial, setFilial] = useState(false);

    const selectableAddresses = useMemo(() => data?.addresses?.filter((f) => !("isSelect" in f) || f.isSelect) ?? [], [data]);

    useEffect(() => {
        if (!filialObj || !data?.addresses?.length) return;

        const selectedCity = data.addresses.find((item) => item.city === filialObj.city);
        const selectedFilial = selectedCity?.address?.find((item) => item.text === filialObj.filial);

        if (selectedCity) {
            setCity(selectedCity);
        }

        if (selectedFilial) {
            setFilial(selectedFilial);
        }
    }, [data, filialObj]);

    useEffect(() => {
        if (selectableAddresses.length === 1) {
            setCity(selectableAddresses[0]);
            setErrorCity(false);
        }
    }, [selectableAddresses, setErrorCity]);

    useEffect(() => {
        if (city?.address?.length === 1) {
            setFilialObj({ city: city.city, filial: city.address[0].text });
            setFilial(city.address[0]);
        } else {
            if (!filialObj?.filial) {
                setFilial(false);
            }
        }
    }, [city, filialObj?.filial, setFilialObj]);

    const getLocationValue = (selectedCity) => {
        if (!selectedCity) return;

        const matchedCity = cityArr?.find((item) => item.city === selectedCity.city);

        if (!matchedCity) return selectedCity;

        return {
            ...selectedCity,
            _id: selectedCity._id || matchedCity._id,
            regionId: selectedCity.regionId || matchedCity.regionId,
        };
    };

    const handleChange = (el, id) => {
        let nextFilialObj = { ...filialObj };

        if (id === "city") {
            setCity(el);
            nextFilialObj.city = el.city;
            delete nextFilialObj.filial;
            delete nextFilialObj.metro;
        } else {
            setFilial(el);
            nextFilialObj[id] = el.text;
        }

        if (selectableAddresses.length === 1) {
            nextFilialObj = {
                ...nextFilialObj,
                [id]: el.text,
                city: selectableAddresses[0].city,
            };
        }

        setFilialObj(nextFilialObj);

        handleUpdateLocation(getLocationValue(id === "city" ? el : city || selectableAddresses[0]));
    };

    return (
        <div className="filial__block">
            {selectableAddresses.length === 1 ? null : <SelectFilialUI id={"city"} error={errorCity} setError={setErrorCity} data={selectableAddresses} onChange={handleChange} title={city ? city.city : "Выберите город"} isEmpty={!city} />}
            <SelectFilialUI
                error={errorFilial}
                setError={setErrorFilial}
                id={"filial"}
                data={city.address}
                disable={!city}
                readOnly={city?.address?.length === 1}
                onChange={handleChange}
                title={filial ? filial.text : data?.title}
                city={city}
                isEmpty={!filial}
            />
        </div>
    );
};

export default FilialBlock;
